<template>
  <div>
    <Tabs :value="tabsValue" v-model="tabsValue" :animated="false">
      <TabPane label="绩效状态" name="1"
        ><Form :label-width="100" label-position="left">
          <Row :gutter="15">
            <Col span="6">
              <FormItem :label="$t('Year')"
                ><!--年份-->
                <DatePicker
                  type="year"
                  v-model="searchItem.year"
                  style="width:100%"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="2">
              <Button
                @click="(total = 0), (pageInfoTab2.pageNo = 1), SearchData()"
                >{{ $t("Search") }}</Button
              ><!--检 索-->
            </Col>
          </Row>
        </Form>
        <Table
          border
          ref="selection"
          :loading="loading"
          :columns="columns"
          :data="data"
        >
          <template slot-scope="{ row }" slot="sendMailFlag" style="width:100%">
            <Checkbox v-model="row.sendMailFlag" disabled></Checkbox>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <Button
              type="warning"
              :disabled="row.status == '结束'"
              icon="md-create"
              size="small"
              style="margin-right: 8px"
              @click="editBtn(row, index)"
              >{{ $t("Edit") }}</Button
            ><!--编辑-->
            <Button
              type="error"
              icon="md-trash"
              :disabled="row.status == '结束'"
              size="small"
              @click="deletedbtn(row, index)"
              >{{ $t("Delete") }}</Button
            ><!--删除-->
          </template>
        </Table>
        <div style="margin:20px 0;">
          <Page style="float: left" :total="total" @on-change="pageChange" />
          <!-- <Button
        style="float: right;margin-left:15px"
        type="primary"
        @click="openBtn()"
        :disabled="loading"
        >{{ $t("开启") }}</Button> -->
          <!-- 开启 -->
          <Button
            style="float: right"
            type="primary"
            @click="addBtn()"
            :disabled="loading"
            >{{ $t("Add") }}</Button
          ><!--新增-->
        </div>
      </TabPane>
      <TabPane label="继任阶段" name="2">
        <Form :label-width="100" label-position="left">
          <Row :gutter="15">
            <Col span="6">
              <FormItem :label="$t('Year')"
                ><!--年份-->
                <DatePicker
                  type="year"
                  v-model="searchItem.yearTab2"
                  style="width:100%"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="2">
              <Button
                @click="(total = 0), (pageInfo.pageNo = 1), searchTab2()"
                >{{ $t("Search") }}</Button
              ><!--检 索-->
            </Col>
          </Row>
        </Form>
        <Table
          border
          ref="selection"
          :loading="loading"
          :columns="columnsTab2"
          :data="dataTab2"
        >
          <template slot-scope="{ row, index }" slot="action">
            <Button
              type="warning"
              :disabled="row.be_enable == '结束'"
              icon="md-create"
              size="small"
              style="margin-right: 8px"
              @click="editBtnTab2(row, index)"
              >{{ $t("Edit") }}</Button
            ><!--编辑-->
          </template>
        </Table>
        <div style="margin:20px 0;">
          <Page
            style="float: left"
            :total="pageInfoTab2.total"
            @on-change="pageChangeTab2"
          />
          <!-- <Button
        style="float: right;margin-left:15px"
        type="primary"
        @click="openBtn()"
        :disabled="loading"
        >{{ $t("开启") }}</Button> -->
          <!--开启-->
          <Button
            style="float: right;margin-left:15px"
            type="primary"
            @click="openBtnTwo()"
            :disabled="loading"
            >{{ $t("开启继任阶段") }}</Button
          >
        </div>
      </TabPane>
    </Tabs>

    <Modal
      v-model="showStatus"
      :title="type == '1' ? $t('Add') : $t('Edit')"
      width="550px"
      ><!--新增--><!--编辑-->
      <div class="center" style="padding: 0 40px;">
        <Form
          :label-width="100"
          label-position="left"
          :model="formItem"
          ref="formItem"
          :rules="rules"
        >
          <FormItem :label="$t('Year')" prop="year"
            ><!--年份-->
            <DatePicker
              type="year"
              v-model="formItem.year"
              transfer
              style="width:100%"
            ></DatePicker>
          </FormItem>
          <FormItem :label="$t('Stage')" prop="achStage"
            ><!--绩效阶段-->
            <RadioGroup
              v-model="formItem.achStage"
              type="button"
              style="width:100%"
            >
              <Radio
                :label="item.code"
                v-for="(item, index) in AchStage"
                :key="index"
                >{{ item.ch_value }}</Radio
              >
            </RadioGroup>
          </FormItem>
          <FormItem :label="$t('Status_Ach')" prop="status"
            ><!--绩效状态-->
            <RadioGroup
              v-model="formItem.status"
              type="button"
              style="width:100%"
            >
              <Radio
                :label="item.code"
                v-for="(item, index) in AchStatus"
                :key="index"
                >{{ item.ch_value }}</Radio
              >
            </RadioGroup>
          </FormItem>
          <FormItem :label="$t('Start_Date')"
            ><!--开始日期-->
            <DatePicker
              type="date"
              v-model="formItem.startDate"
              transfer
              style="width:100%"
            ></DatePicker>
          </FormItem>
          <FormItem :label="$t('End_Date')"
            ><!--结束日期-->
            <DatePicker
              type="date"
              v-model="formItem.endDate"
              transfer
              style="width:100%"
            ></DatePicker>
          </FormItem>
          <FormItem :label="$t('发送邮件')"
            ><!--发送邮件-->
            <Checkbox v-model="formItem.sendMailFlag"></Checkbox>
          </FormItem>
          <FormItem :label="$t('BU HRD取值')" v-show="formItem.achStage == '年终总结'"
            ><!--发送邮件-->
            <Select v-model="formItem.buhrdValue" clearable style="width:100%">
              <Option
                v-for="item in HRDGetValue"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.value : item.value }}</Option
              >
            </Select>
            <span style="color: red;">用于绩效结果确认流程</span>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="confirm">{{ $t("Confirm") }}</Button
        ><!--确定-->
        <Button @click="cancel">{{ $t("Cancel") }}</Button
        ><!--取消-->
      </div>
    </Modal>
    <Modal
      v-model="modalValue"
      :title="modalStatus == '1' ? '开启继任阶段' : '编辑继任阶段'"
      footer-hide
    >
      <Form
        :label-width="100"
        label-position="left"
        :model="addTwoItem"
        ref="addTwoItemRef"
        :rules="addTwoItemRules"
      >
        <Row>
          <Col span="24">
            <FormItem label="阶段名称" prop="stage_name">
              <Input
                v-model="addTwoItem.stage_name"
                style="width: 380px;"
              ></Input>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="开始时间" prop="stage_start_date">
              <DatePicker
                type="date"
                v-model="addTwoItem.stage_start_date"
                style="width: 380px;"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="结束时间" prop="stage_end_date">
              <DatePicker
                type="date"
                v-model="addTwoItem.stage_end_date"
                style="width: 380px;"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div
        style="display: flex;
    flex-direction: row-reverse;"
      >
        <Button @click="startJD" type="primary">确定</Button>
        <Button @click="modalValue = false" style="margin-right: 15px;"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      formItem: {
        year: "",
        status: "",
        achStage: "",
        sendMailFlag: true
      },
      data: [],
      tabsValue: "1",
      modalStatus: "1",
      showStatus: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      pageInfoTab2: {
        total: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      type: "0",
      loading: false,
      id: "",
      modalValue: false,
      addTwoItem: {
        stage_name: "",
        stage_start_date: ""
      },
      searchItem: {},
      searchAction: 0,
      AchStage: [],
      AchStatus: [],
      dataTab2: [],
      HRDGetValue:[
        {
          code : "0",
          value : "直线经理"
        },
        {
          code : "1",
          value : "虚线经理"
        }
      ]
    };
  },
  computed: {
    rules() {
      return {
        year: [{ required: true, message: this.$t("请选择年份") }], //请选择年份
        status: [{ required: true, message: this.$t("请选择状态") }], //请选择状态
        achStage: [{ required: true, message: this.$t("请选择绩效阶段") }] //请选择绩效阶段
      };
    },
    addTwoItemRules() {
      return {
        stage_name: [{ required: true, message: this.$t("请填写阶段名称") }], //请选择年份
        stage_start_date: [
          { required: true, message: this.$t("请选择开始时间") }
        ] //请选择状态
      };
    },
    columns() {
      return [
        {
          title: this.$t("Year"), //"年份"
          key: "year",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h("span", this.date.dateVal(params.row.year, "YYYY"));
          }
        },
        {
          title: this.$t("Stage"), //"绩效阶段"
          key: "achStage",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.AchStage.filter(
                item => item.code == params.row.achStage
              ).map(res => res.ch_value)
            );
          }
        },
        {
          title: this.$t("Status_Ach"), //"绩效状态"
          key: "status",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.AchStatus.filter(item => item.code == params.row.status).map(
                res => res.ch_value
              )
            );
          }
        },
        {
          title: this.$t("Start_Date"), //"开始日期"
          key: "startDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.startDate, "YYYY/MM/DD")
            );
          }
        },
        {
          title: this.$t("End_Date"), //"结束日期"
          key: "endDate",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.endDate, "YYYY/MM/DD")
            );
          }
        },
        {
          title: this.$t("Emp_Ach_mess16"), //"是否发送邮件"
          slot: "sendMailFlag",
          align: "center",
          minWidth: 150
        },
        {
          title: this.$t("Action"), //"操作"
          slot: "action",
          align: "center",
          minWidth: 200
        }
      ];
    },
    columnsTab2() {
      return [
        {
          title: this.$t("Year"), //"年份"
          key: "year",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h("span", this.date.dateVal(params.row.year, "YYYY"));
          }
        },
        {
          title: "阶段名称", //"年份"
          key: "stage_name",
          align: "center",
          minWidth: 120
        },
        {
          title: "阶段开始日期", //"开始日期"
          key: "stage_start_date",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.stage_start_date, "YYYY/MM/DD")
            );
          }
        },
        {
          title: "阶段结束日期", //"结束日期"
          key: "stage_end_date",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.stage_end_date, "YYYY/MM/DD")
            );
          }
        },
        {
          title: "状态",
          key: "be_enable",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Action"), //"操作"
          slot: "action",
          align: "center",
          minWidth: 200
        }
      ];
    }
  },
  created() {
    this.search();
    this.searchTab2();
    this.getListData();
  },
  watch: {
    "formItem.month"(val) {
      if (val != null && val.length == 1) {
        this.$set(this.formItem, "month", "0" + val);
        return (val = "0" + val);
      }
    }
  },
  methods: {
    pageChangeTab2(val) {
      this.pageInfoTab2.pageNo = val;
      this.searchTab2();
    },
    searchTab2() {
      this.loading = true;
      this.axios
        .post("/AchievementsStatus/searchSuccessorStage", {
          ...this.pageInfoTab2,
          year: this.date.dateVal(this.searchItem.yearTab2, "yyyy")
        })
        .then(res => {
          if (res) {
            this.loading = false;
            this.dataTab2 = res.data;
            this.pageInfoTab2.total = Number(res.pageInfo.total);
          }
        });
    },
    SearchData() {
      this.searchAction = 1;
      this.search();
    },
    getListData() {
      axios.post("/AchievementsStatus/searchAchLabel", {}).then(res => {
        if (res) {
          this.AchStage = res.AchStage;
          this.AchStatus = res.AchStatus;
        }
      });
    },
    search() {
      let obj = {
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      if (this.searchAction == 1) {
        this.searchItem.year = this.searchItem.year
          ? this.date.dateVal(this.searchItem.year, "YYYY")
          : null;
        this.searchItem.status = this.searchItem.status
          ? this.searchItem.status
          : null;
        obj.status = this.searchItem.status;
        obj.year = this.searchItem.year;
      }
      this.searchAction = 0;
      this.loading = true;
      axios
        .post("AchievementsStatus/selectAchievementStatus", obj)
        .then(res => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            this.total = Number(res.pageInfo.total);
            this.data.forEach(el => {
              el.sendMailFlag = !!+el.sendMailFlag;
            });
          }
        });
    },
    editBtn(row, index) {
      this.type = "0";
      this.id = row.id;
      this.showStatus = true;
      this.formItem = JSON.parse(JSON.stringify(row));
      this.$set(this.formItem, "year", row.year);
      this.formItem.endDate = row.endDate;
      this.formItem.month = row.month ? Number(row.month) : null;
      this.$set(this.formItem, "status", row.status);
      row.sendMailFlag = !!+row.sendMailFlag;
    },
    editBtnTab2(row, index) {
      this.addTwoItem = JSON.parse(JSON.stringify(row));
      this.modalStatus = "2";
      this.modalValue = true;
    },

    deletedbtn(row, index) {
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_delete"),
        content: "",
        onOk: () => {
          let obj = {
            id: row.id
          };
          this.loading = true;
          axios
            .post("AchievementsStatus/deleteAchievementStatus", obj)
            .then(res => {
              this.loading = false;
              this.search();
            });
        }
      });
    },
    addBtn() {
      this.showStatus = true;
      this.type = "1";
      this.formItem = {};
      // this.$refs["formItem"].resetFields();
      // this.formItem.month = null;
      // this.formItem.endDate = null;
      // this.formItem.startDate = null;
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.search();
    },
    confirm() {
      if (this.formItem.startDate > this.formItem.endDate) {
        return this.$Message.error(this.$t("开始日期 不能 大于 结束日期")); //开始日期 不能 大于 结束日期
      }
      if (this.type == "0") {
        this.$refs["formItem"].validate(valid => {
          if (valid) {
            this.$Modal.confirm({
              title: this.$notice("sureSave"),
              content: "",
              onOk: () => {
                let formItem = JSON.parse(JSON.stringify(this.formItem));
                this.loading = true;
                formItem.year = this.date.dateVal(formItem.year, "yyyy");
                formItem.endDate = this.date.dateVal(
                  formItem.endDate,
                  "YYYY-MM-DD"
                );
                formItem.startDate = this.date.dateVal(
                  formItem.startDate,
                  "YYYY-MM-DD"
                );
                formItem.sendMailFlag
                  ? (formItem.sendMailFlag = "1")
                  : (formItem.sendMailFlag = "0");
                let obj = {
                  ...formItem,
                  id: this.id,

                  cteateUserId: JSON.parse(sessionStorage.getItem("userInfo"))
                    .userId
                };
                axios
                  .post("AchievementsStatus/updateAchievementStatus", obj)
                  .then(res => {
                    this.loading = false;
                    if (res) {
                      this.sendMail(obj);
                      this.search();
                      this.showStatus = false;
                    }
                  });
              }
            });
          } else {
            this.$message.error(this.$t("Please_fill_in_required_items")); //请填写必填项！
          }
        });
      } else if (this.type == "1") {
        this.$refs["formItem"].validate(valid => {
          if (valid) {
            this.loading = true;
            let formItem = JSON.parse(JSON.stringify(this.formItem));
            formItem.year = this.date.dateVal(formItem.year, "yyyy");
            formItem.month =
              formItem.month == null ? null : Number(formItem.month);
            formItem.endDate = formItem.endDate
              ? this.date.dateVal(formItem.endDate, "YYYY-MM-DD")
              : null;
            formItem.startDate = formItem.startDate
              ? this.date.dateVal(formItem.startDate, "YYYY-MM-DD")
              : null;
            formItem.sendMailFlag
              ? (formItem.sendMailFlag = "1")
              : (formItem.sendMailFlag = "0");
            let obj = {
              ...formItem,
              cteateUserId: JSON.parse(sessionStorage.getItem("userInfo"))
                .userId
            };
            axios
              .post("AchievementsStatus/insertAchievementStatus", obj)
              .then(res => {
                this.loading = false;
                if (res) {
                  this.sendMail(obj);
                  this.search();
                  this.showStatus = false;
                }
              });
          } else {
            this.$message.error(this.$t("Please_fill_in_required_items")); //请填写必填项！
          }
        });
      }
    },
    sendMail(obj) {
      axios.post("/AchievementsStatus/sendMailUtil", obj).then(res => {});
    },
    cancel() {
      this.showStatus = false;
      this.$refs["formItem"].resetFields();
    },
    openBtnTwo() {
      this.modalStatus = "1";
      this.modalValue = true;
      this.addTwoItem = {};
    },
    startJD() {
      let beginDate = this.date.dateVal(
        this.addTwoItem.stage_start_date,
        "YYYY-MM-DD"
      );
      let endDate = this.date.dateVal(
        this.addTwoItem.stage_end_date,
        "YYYY-MM-DD"
      );
      if (beginDate > endDate) {
        this.$Message.error("结束时间要大于开始时间");
      } else {
        this.$refs["addTwoItemRef"].validate(vavid => {
          if (vavid) {
            this.$Modal.confirm({
              title:
                this.modalStatus == "1"
                  ? "确认开启继任继任阶段?"
                  : "确认编辑继任阶段？",
              onOk: () => {
                if (this.modalStatus == "1") {
                  this.axios
                    .post("/AchievementsStatus/openSuccessorStage", {
                      ...this.addTwoItem,
                      stage_end_date: this.date.dateVal(
                        this.addTwoItem.stage_end_date,
                        "YYYY-MM-DD"
                      ),
                      stage_start_date: this.date.dateVal(
                        this.addTwoItem.stage_start_date,
                        "YYYY-MM-DD"
                      )
                    })
                    .then(res => {
                      if (res) {
                        this.$Message.success(res);
                        this.pageInfoTab2.pageNo = 1;
                        this.searchTab2();
                        this.modalValue = false;
                      }
                    });
                } else {
                  this.axios
                    .post("/AchievementsStatus/updateSuccessorStage", {
                      ...this.addTwoItem,
                      stage_end_date: this.date.dateVal(
                        this.addTwoItem.stage_end_date,
                        "YYYY-MM-DD"
                      ),
                      stage_start_date: this.date.dateVal(
                        this.addTwoItem.stage_start_date,
                        "YYYY-MM-DD"
                      )
                    })
                    .then(res => {
                      if (res) {
                        this.$Message.success(res);
                        this.pageInfoTab2.pageNo = 1;
                        this.searchTab2();
                        this.modalValue = false;
                      }
                    });
                }
                this.modalValue = false;
              }
            });
          } else {
            this.$Message.error("请输入完整");
          }
        });
      }
    },
    openBtn() {
      this.loading = true;
      axios.post("/successorInfo/saveSuccessorInfoData", {}).then(res => {
        this.loading = false;
        if (res) {
          this.$Message.success(res);
          this.search();
        }
      });
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PerformanceStatus.vue